import { useConnector } from 'react-instantsearch-hooks-web';
import connectStats from 'instantsearch.js/es/connectors/stats/connectStats';

import type { StatsConnectorParams, StatsWidgetDescription } from 'instantsearch.js/es/connectors/stats/connectStats';

export type UseStatsProps = StatsConnectorParams;

export function useStats(props?: UseStatsProps) {
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats, props);
}

export const FoundHits = (props: UseStatsProps) => {
  const { nbHits } = useStats(props);

  return (
    <div className="sr-found-hits-number">
      <span
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: theme.locales.resultsLabel.replace('{{ quantity }}', Number(nbHits).toLocaleString()),
        }}
      />
    </div>
  );
};
